import LazyLoad from './../library/LazyLoad';

export default class SoldBusinesses {

	constructor() {
		this.instance = self;
	}

	static init() {
		const self = new SoldBusinesses;
		self.attachEvents();
	}

	attachEvents() {
		const self = this;

		window.site.animateSoldBusinesses = function() {
			const lazyLoad = new LazyLoad();
			lazyLoad.fadeInStaggerElement('.js-sold-businesses-results');
		};

		$(document).on('click', '.js-sold-businesses-pagination', function(e) {
			e.preventDefault();
			self.loadPage($(this).data('page'));
		});
	}

	loadPage(page) {
		const self = this,
			$form = $('.js-sold-businesses-form');

		$form.find('input[name="page"]').val(page);
		$form.submit();
	}
}
